import { FileArchive, FileText, ImageOff } from "lucide-react";
import { fileTypeLabel } from "@/lib/photo-files";
import { cn } from "@/lib/utils";
import type { Photo } from "@/schemas/photos";

/**
 * What stands in for a picture: a file with no picture (a PDF, a zip), a row whose file
 * was not pulled for this POC, or an image that would not load. These are real rows.
 */
export function PhotoFileFace({
  photo,
  failed = false,
  className,
}: {
  photo: Photo;
  failed?: boolean;
  className?: string;
}) {
  const missing = photo.kind === "missing";
  const Icon = missing || failed ? ImageOff : photo.mime?.includes("zip") ? FileArchive : FileText;
  return (
    <span
      className={cn(
        "flex size-full flex-col items-center justify-center gap-1.5 p-3 text-center",
        className,
      )}
    >
      <Icon className="size-7 shrink-0 opacity-60" />
      <span className="text-xs font-semibold">
        {missing
          ? "File not pulled for this POC"
          : failed
            ? "Could not load"
            : fileTypeLabel(photo.fileName)}
      </span>
      <span className="line-clamp-2 max-w-full text-[11px] break-all opacity-70">
        {photo.fileName}
      </span>
    </span>
  );
}
